import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-radio-group',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class RadioGroup extends mixins(AbstractField) {
  @Prop([String, Number, Boolean]) readonly value: string | number | boolean;
  @Prop({ type: Array, default: () => [] }) readonly options: object[];

  get model(): string | number | boolean {
    return !!this.value;
  }
  set model(val: string | number | boolean) {
    this.$emit('input', !!val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, !!val);
      });
    }
  }

  beforeMount() {
    this.model = !!this.value;
  }

  // onEnterKey() {
  //   this.$emit('enter-key');
  // }

  // updated () { }

  // destroyed () { }
}
